
import {map} from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import { PlatformHttpService } from '../../common/http/service/platformhttp.service';
import { Observable, Subject} from 'rxjs';
import { Constants } from '../../common/constants';
import { HttpResponse } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AddressService implements OnDestroy {

  public _refreshAddressesSubject: Subject<any> = new Subject();
  public _addressResponse: Subject<any> = new Subject();
  public addressResponse: Observable<any> = this._addressResponse.asObservable();
  private unsubscribe: Subject<void> = new Subject();

  constructor(public platformhttpservice: PlatformHttpService) {
        this._refreshAddressesSubject
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(this.getAllAddressForCustomer.bind(this));
  }

  public updateAddresses(): void {
    this._refreshAddressesSubject.next('refresh');
  }

  public getAllAddressForCustomer(): void {
          this.platformhttpservice.get(Constants.ADDRESS)
                                  .pipe(takeUntil(this.unsubscribe))
                                  .subscribe(e => {
                                    this._addressResponse.next(e);
                                  });
        }

  public findAllStoreAddresses() {
     return this.platformhttpservice.get(Constants.ADDRESS + Constants.STORE);
  }

  public findEligableStoreAddressesForCurrentOrder() {
    return this.platformhttpservice.get(Constants.ADDRESS + Constants.STORE + Constants.ELIGIBLE);
  }



  public getDefaultAddressesForCustomer(): Observable<any> {
         return this.platformhttpservice.get(Constants.ADDRESS + Constants.DEFAULT);
  }

  public create(data: any, addAddressToCurrentOrder?: boolean): Observable<any> {
         let url = Constants.ADDRESS;
         if (addAddressToCurrentOrder) {
          url = url + Constants.FOR_ORDER;
         }
         return this.platformhttpservice.post(url, data);
    }

    public delete(addressId): Observable<any> {
         const url = Constants.ADDRESS + '/' + addressId;
         return this.platformhttpservice.delete(url, true).pipe(map((resp: HttpResponse<any>) => resp.status));
    }

  public changeAddressForOrder(addressChangeRequest): Observable<any> {
    return this.platformhttpservice.post(Constants.ADDRESS + '/change' + Constants.FOR_ORDER, addressChangeRequest, null, true).pipe(
                    map((resp: HttpResponse<any>) => {
                         return resp.status;
                     }));
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

}
